// schema.org VideoObject nodes for the tutorial videos on a Learn or Docs page.
// Shared by the client (MetaHead) and the SSR head so crawlers see the same markup.
const { videos } = require('../content/tutorialVideos.json');

const SITE_URL = 'https://gab.ai';

function isoDurationFromSeconds(seconds) {
  const total = Math.max(1, Math.round(Number(seconds) || 0));
  const minutes = Math.floor(total / 60);
  return `PT${minutes ? `${minutes}M` : ''}${total % 60}S`;
}

function tutorialVideosFor(guideType, slug) {
  const key = guideType === 'learn' ? 'learn' : 'docs';
  const target = String(slug || 'index').toLowerCase();
  return videos.filter(video => (video[key] || []).includes(target));
}

/** Maps `/learn`, `/learn/x`, `/docs`, `/docs/x` to [guideType, slug]. */
function guidePageFromPath(pagePath) {
  const match = String(pagePath || '').match(/^\/(learn|docs)(?:\/([^/?#]+))?\/?$/);
  return match ? [match[1], match[2] || 'index'] : null;
}

function tutorialVideoNodes(pagePath, pageUrl) {
  const page = guidePageFromPath(pagePath);
  if (!page) return [];
  const url = pageUrl || `${SITE_URL}${pagePath}`;
  return tutorialVideosFor(page[0], page[1]).map(video => ({
    '@type': 'VideoObject',
    '@id': `${url}#video-${video.slug}`,
    name: video.title,
    description: video.description,
    thumbnailUrl: [video.poster],
    uploadDate: `${video.uploadDate}T00:00:00Z`,
    duration: isoDurationFromSeconds(video.duration),
    contentUrl: video.src,
    url,
    inLanguage: 'en-US',
    isFamilyFriendly: true,
    isAccessibleForFree: true,
    ...(video.transcript ? { transcript: video.transcript } : {}),
    publisher: { '@id': `${SITE_URL}#organization` },
  }));
}

module.exports = { tutorialVideoNodes, tutorialVideosFor, guidePageFromPath, isoDurationFromSeconds };
